
const CheckMyTicket = () => {
    return null;
};

export default CheckMyTicket;